import React from 'react';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import { Search } from '../../../common/mix-search/index';
import { connect } from 'react-redux';
import ConstCommon from './../../../common/Const';

const SearchBox = props => {
  const {
    listSearch,
    typeSearch,
    dateRangeOption,
    onChange,
    disabled,
    currentSearch,
  } = props;
  return (
    <Search
      disabled={disabled}
      listSearch={listSearch}
      listKeyFilter={[
        ConstCommon.listOrganization.TICKER,
        ConstCommon.listOrganization.ORGAN_SHORT_NAME,
      ]}
      currentSearch={currentSearch}
      typeSearch={typeSearch}
      dateRangeOption={dateRangeOption}
      clickItemSearch={onChange}
      mainKey={'ticker'}
      sortKey={'ticker'}
      enableSearchByTicker={true}
    />
  );
};

const mapStateToProps = state => {
  return {
    listSearch: state[COMMON_REDUCER_NAME].listOrganizationSearch,
  };
};

export default connect(mapStateToProps)(SearchBox);
